<template>
	<div
		ref="navContainer"
		class="dropdown__navigation-container"
		:class="{ '-is-open': isOpen }"
	>
		<button
			ref="navButton"
			class="dropdown__navigation-toggle"
			aria-haspopup="true"
			:aria-expanded="isOpen"
			role="navigation"
			@click="toggleDropdown()"
			@keyup.down="keyboardOpen()"
			@keyup.esc="keyboardClose()"
			@focus="onFocus()"
			@blur="onBlur()"
		>
			{{ title }}
			<span class="dropdown__navigation-arrow"></span>
		</button>
		<nav role="navigation" class="dropdown__navigation-menu">
			<ul>
				<li
					v-for="(item, index) in items"
					:key="index"
					:class="`dropdown__navigation-item dropdown__navigation-${index}`"
				>
					<a
						ref="navLink"
						:href="item.url"
						:aria-label="item.label"
						@keydown.tab="tabNavigation(index)"
						@keyup="keyboardNavigation($event, index)"
					>
						{{ item.title }}
					</a>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script>
export default {
	name: 'DropdownNavigation',
	props: {
		title: { type: String, required: true, default: 'placeholder' },
		items: { type: Array, required: true },
	},
	data() {
		return {
			isOpen: false,
			isFocused: false,
			currentIndex: 0,
		};
	},
	mounted: function () {
		document.addEventListener('click', this.onClick);
		document.addEventListener('keydown', this.onKeyboard);
	},

	beforeDestroy: function () {
		document.removeEventListener('click', this.onClick);
		document.removeEventListener('keydown', this.onKeyboard);
	},

	methods: {
		onClick: function (event) {
			if (this.isOpen) {
				if (event.target != this.$refs.navButton) {
					this.isOpen = false;
				}
			}
		},

		onKeyboard: function (event) {
			if (this.isOpen || this.isFocused) {
				if (event.keyCode == 40 || event.keyCode == 38) {
					event.preventDefault();
				}
			}
		},

		onFocus: function () {
			this.isFocused = true;
		},

		onBlur: function () {
			this.isFocused = false;
		},

		toggleDropdown: function () {
			this.isOpen = !this.isOpen;
		},

		keyboardOpen: function () {
			this.isOpen = true;

			this.$refs.navLink[0].focus();
		},

		keyboardClose: function () {
			this.isOpen = false;
		},

		tabNavigation: function (index) {
			this.currentIndex = index;
			const parentNext = this.$refs.navLink[this.currentIndex + 1];

			if (event.shiftKey) {
				return;
			}

			this.isOpen = Boolean(parentNext);
		},

		keyboardNavigation: function (event, index) {
			this.currentIndex = index;
			const parentNext = this.$refs.navLink[this.currentIndex + 1];
			const parentPrev = this.$refs.navLink[this.currentIndex - 1];

			if (event.keyCode === 38) {
				if (!parentPrev) {
					this.$refs.navButton.focus();
				} else {
					parentPrev.focus();
				}
			}

			if (event.keyCode === 40) {
				if (parentNext) {
					parentNext.focus();
				}
			}

			if (event.keyCode === 27 && this.isOpen) {
				this.isOpen = false;
			}
		},
	},
};
</script>
<style lang="scss">
.dropdown__navigation-container {
	display: inline-block;
	position: relative;

	&.-is-open {
		& .dropdown__navigation-arrow {
			transform: translateY(0%) rotate(225deg);
		}
		& .dropdown__navigation-menu {
			visibility: visible;
		}
	}

	& .dropdown__navigation-toggle {
		background: none;
		border: 1px solid black;
		cursor: pointer;
		padding: 5px;
		padding-right: 3em;
		position: relative;
		text-align: left;
		-webkit-appearance: none;
	}

	& .dropdown__navigation-arrow {
		border: solid black;
		border-width: 0 2px 2px 0;
		height: 0.5rem;
		outline: none;
		pointer-events: none;
		position: absolute;
		right: 1em;
		top: 50%;
		transform: translateY(-60%) rotate(45deg);
		width: 0.5rem;
	}

	& .dropdown__navigation-menu {
		background: #fff;
		border: 1px solid #000;
		border-top: none;
		box-sizing: border-box;
		position: absolute;
		top: 100%;
		visibility: hidden;
		width: 100%;
		z-index: 10;
	}

	& .dropdown__navigation-menu ul {
		list-style: none;
		margin: 0;
		padding: 0;

		& li {
			& a {
				display: block;
				padding: 5px;

				&:hover,
				&:focus {
					background: gray;
				}
			}
			&:last-child a {
				padding: 5px;
			}
		}
	}
}
</style>
